module.exports = __webpack_public_path__ + "static/media/milestonecheck.d2c942b2.svg";